import React, { useEffect, useState } from "react";
import { fetchBrands } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import BrandCard from "@/components/BrandCard";
import SearchBox from "@/components/SearchBox";
import Seo from "@/components/Seo";

export default function BrandsIndex() {
  const { t, locale } = useI18n();
  const [brands, setBrands] = useState([]);
  const [sort, setSort] = useState("alpha");

  useEffect(() => {
    fetchBrands({ sort, limit: 200 }).then((d) => setBrands(d.brands || []));
  }, [sort]);

  return (
    <>
      <Seo title={t.nav_brands} description="All indexed brands." canonicalPath="/brands" locale={locale} />
      <section className="border-b" style={{ borderColor: "var(--bp-border)" }}>
        <div className="bp-container py-12">
          <h1 className="font-serif text-5xl md:text-6xl leading-none mb-4">{t.nav_brands}</h1>
          <div className="max-w-2xl"><SearchBox /></div>
        </div>
      </section>
      <div className="bp-container py-8">
        <div className="mb-6 flex justify-end gap-1 text-xs font-mono">
          <button onClick={() => setSort("alpha")} className={`px-3 py-1.5 border ${sort === "alpha" ? "bg-black text-white border-black" : ""}`} style={{ borderColor: "var(--bp-border)" }} data-testid="brands-sort-alpha">{t.sort_alpha}</button>
          <button onClick={() => setSort("recent")} className={`px-3 py-1.5 border ${sort === "recent" ? "bg-black text-white border-black" : ""}`} style={{ borderColor: "var(--bp-border)" }} data-testid="brands-sort-recent">{t.sort_recent}</button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {brands.length === 0 ? (
            <div
              className="col-span-full border p-10 md:p-14 bg-white"
              style={{ borderColor: "var(--bp-border)" }}
              data-testid="brands-empty-state"
            >
              <div className="uppercase text-xs tracking-[0.3em] mb-4" style={{ color: "var(--bp-text-muted)" }}>{t.empty_kicker}</div>
              <div className="font-serif text-3xl leading-tight mb-3">{t.empty_title}</div>
              <p className="text-base leading-relaxed max-w-2xl" style={{ color: "var(--bp-text-secondary)" }}>{t.empty_body}</p>
            </div>
          ) : (
            brands.map((b) => <BrandCard key={b.id} brand={b} />)
          )}
        </div>
      </div>
    </>
  );
}
